export default {
  path: '/wecode/old-market',
  auth: false,
  preload: false,
  key: 'market',
  isStatic: true,
  component: () => import('./index')
};
